"use client"

import * as React from "react"
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { cn } from "@/lib/utils"

interface VideoDialogProps {
  videoId: string
  trigger?: React.ReactNode
  className?: string
  aspectRatio?: number
}

export default function VideoDialog({ 
  videoId, 
  trigger,
  className,
  aspectRatio = 16 / 9
}: VideoDialogProps) {
  const [isOpen, setIsOpen] = React.useState(false)
  
  const paddingBottom = `${(1 / aspectRatio) * 100}%`

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent 
        className={cn(
          "max-w-[95vw] sm:max-w-[85vw] md:max-w-[1000px] lg:max-w-[1200px] xl:max-w-[1400px] p-0 overflow-hidden bg-black border-none",
          className
        )}
        showCloseButton={true}
      >
        <DialogTitle className="sr-only">Video Demo</DialogTitle>
        <div 
          className="relative w-full" 
          style={{ paddingBottom }}
        >
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=${isOpen ? 1 : 0}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

